import { get } from 'lodash';
import { v4 as uuid } from 'uuid';

import { FieldId } from '~/evifields/src/types/FieldId';
import { Filter } from '~/evifields/src/types/Filter';
import { SearchItem } from '~/redux/api/methods/evisearch';
import { Nullable } from '~/types/Nullable';

import {
  testHasMixedOperatorInSection,
  testHasNestedSections,
  testIsOperator,
  testIsSection,
} from '../search/utils/queryUtils';
import { SearchQuery } from './types';

export const getDocumentHandlers = (item: Nullable<SearchItem>) =>
  get(
    item,
    'selected_field_values.document_handler_id_Document.value_structured',
    [],
  );

export const toTableViewFields = (columnOrder: string[]) =>
  columnOrder.map((field_id, column_number) => ({ field_id, column_number }));

export const buildResultTable = (
  columnOrder: string[],
  staticColumns: string[],
) =>
  columnOrder
    .filter((column) => !staticColumns.includes(column))
    .map((column, index) => ({ filterId: column, columnIndex: index }));

export const toPinnedFilters = (fieldIds: Array<string | number>): Filter[] =>
  fieldIds.map((fieldId) => ({
    id: uuid(),
    fieldId: (Number(fieldId) || fieldId) as FieldId,
    operatorId: null,
    values: [],
  }));

export const testIsQueryBuilderSupported = (
  queryBuilder?: SearchQuery,
  isComplexQuery?: boolean,
): boolean => {
  if (!queryBuilder || isComplexQuery === false) return true;
  return (
    !testHasMixedOperatorInSection(queryBuilder) &&
    !testHasNestedSections(queryBuilder) &&
    queryBuilder.every(
      (queryEntity) =>
        testIsSection(queryEntity) || testIsOperator(queryEntity),
    )
  );
};
